var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87805 11.5366H1V30.7561H29V11.5366H19.6341",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4374 22.7802C14.8279 23.1708 15.4611 23.1708 15.8516 22.7802L22.2156 16.4163C22.6061 16.0257 22.6061 15.3926 22.2156 15.0021C21.8251 14.6115 21.1919 14.6115 20.8014 15.0021L15.1445 20.6589L9.48768 15.0021C9.09715 14.6115 8.46399 14.6115 8.07346 15.0021C7.68294 15.3926 7.68294 16.0257 8.07346 16.4163L14.4374 22.7802ZM16.1445 0.999949C16.1445 0.447664 15.6968 -5.14743e-05 15.1445 -5.14984e-05C14.5922 -5.15226e-05 14.1445 0.447664 14.1445 0.999948L16.1445 0.999949ZM16.1445 22.0731L16.1445 0.999949L14.1445 0.999948L14.1445 22.0731L16.1445 22.0731Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.69571729b6ce836439f04162fcd36537.svg";
export { ForwardRef as ReactComponent };